<template>
<div>
    <v-breadcrumbs
      :items="breadcrumbs"
      large
      style="padding-bottom: 0px"
    ></v-breadcrumbs>
  <div class="d-flex justify-center">
  <v-card width="800" class="mt-5">
    <v-card-title>Guides</v-card-title>
    <v-divider></v-divider>
    <v-card-text style="font-size:18px;text-align:left">
        <ul>
            <li class="mb-2"><a href="http://ecal.scientiacloud.com/UNNC%20E-Calendar%20User%20Guide%20(PC).pdf">UNNC E-Calendar User Guide (PC)</a></li>
            <li class="mb-2"><a href="http://ecal.scientiacloud.com/UNNC%20E-Calendar%20User%20Guide%20(Mobiles).pdf">UNNC E-Calendar User Guide (Mobiles)</a></li>
        </ul>
        
    </v-card-text>
  </v-card>
  </div>
</div>
</template>

<script>
export default {
    name: 'Guide',
    data: ()=>{
      return {
        breadcrumbs: [
        {
          text: "< Home",
          href: "",
          disabled: false,
          href: "/",
        },
        {
          text: "Guides",
          href: "",
          disabled: false,
        },
      ],
      }
    }
}
</script>

<style>

</style>